export interface ISeller {
    type: ESellerType;
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    contactName?: string | undefined;
    accountNumber?: string | undefined;
    abn?: string | undefined;
    leadEmail?: string | undefined;
    dealershipId?: string | undefined;
    selectedStoreId?:
        | undefined
        | {
              storeId: string;
              storeSelectorId: string;
              coordinates: {
                  lat: number;
                  lng: number;
              };
          }[];
}

export enum ESellerType {
    DEALERSHIP = 'DEALERSHIP',
    PRIVATE = 'PRIVATE',
    UNKNOWN = 'UNKNOWN',
}

export const initialSellerState: ISeller = {
    type: ESellerType.DEALERSHIP,
};
